import { render, staticRenderFns } from "./plmtech-project-list.vue?vue&type=template&id=5e40db78&scoped=true"
import script from "./plmtech-project-list.vue?vue&type=script&lang=js"
export * from "./plmtech-project-list.vue?vue&type=script&lang=js"
import style0 from "./plmtech-project-list.vue?vue&type=style&index=0&id=5e40db78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e40db78",
  null
  
)

export default component.exports